import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation, useTranslation } from "react-i18next";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Axios, { AxiosResponse } from "axios";
import RefreshIcon from "../../assets/img/refreshIcon.png";
//import { process.env.REACT_APP_API_URL_CONFIRMPAYMENT } from '../../constant'
import { paymentofflineActions, masterActions } from "../../_actions";
import Pagination from "@material-ui/lab/Pagination";
import Loading from "../../components/Loader/Loading";
import moment from "moment";
import "moment-timezone";
import "./table.scss";
import { Button } from "@material-ui/core";
import DownloadIcon from "@mui/icons-material/Download";
import ExportJsonDataToExcel from "../exportPopup/ExportJsonDataToExcel";
import ExportExcelPopup from "../exportPopup/ExportExcelPopup";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(() => ({
  root: {
    padding: "25px",
    textAlign: "center",
    // width: "517px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    // margin: 0,
    padding: theme.spacing(1),
    textAlign: "center",
    marginTop: "20px",
    display: "block",
  },
}))(MuiDialogActions);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {},
}))(TableRow);

function createData(
  docname,
  doctype,
  pono,
  docdate,
  duedate,
  noofdueday,
  totalamount,
  status
) {
  return {
    docname,
    doctype,
    pono,
    docdate,
    duedate,
    noofdueday,
    totalamount,
    status,
  };
}

const useStyles = makeStyles({
  refreshButton: {
    background: "#ffffff",
    border: "0px",
  },
  loadingOne: {
    textAlign: "center",
    margin: "5px 0",
  },
  table: {
    minWidth: 700,
  },
  textRight: {
    textAlign: "right !important",
  },
  tableBody: {
    "& th": {
      padding: "10px !important",
    },
    "& td": {
      padding: "10px !important",
    },
  },
});

export default function PaymentHistoryTable(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const custNo = localStorage.getItem("CustomerNumber");
  const rows = props.paymentHistory && props.paymentHistory;
  const rowsData = props.paymentHistory && props.paymentHistory;
  let userName = localStorage.getItem("userData");
  const [loading, setSetloading] = React.useState(false);
  let page = props.page;
  const selectedLangCode = localStorage.getItem("lancode");
  userName = JSON.parse(userName);
  
  function findBU(divType) {
    let company = "SCCC";
    if (divType === "Concrete") {
        company = "SCCO"
    }
    if (divType === "Conwood") {
        company = "Conwood"
    }
    return company
  }

  const viewPdfFile = (
    paymentRefNo,
    transationdate,
    statusType,
    reciptnumber,
    division,
    reciptyear,
    history = "history",
  ) => {
    console.log(
      "hello",
      { paymentRefNo },
      { transationdate },
      { statusType },
      { reciptnumber },
      { history },
      { division }
    );
    if (statusType === "Receipt") {
      setSetloading(true);
      Axios({
        method: "GET",
        url:
          process.env.REACT_APP_API_URL_CONFIRMPAYMENT +
          `/downloadRecipt?customernumber=${custNo}&invoicenumber=${reciptnumber}&division=${division}&year=${reciptyear}`,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
          "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
        },
      })
        // .then((res) => res.json())
        .then(async (response) => {
          setSetloading(false);
          var link = document.createElement("a");
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = await URL.createObjectURL(file);
          link.href = window.URL.createObjectURL(file);
          link.download = `Receipt_${findBU(division)}_` + reciptnumber + ".pdf";
          link.click();
          // setIsLoadingDownload(false)
          return response.data;
        });
    } else {
      var transationdateFormat = moment(transationdate).format("DD-MM-YYYY");
      setSetloading(true);
      Axios({
        method: "GET",
        url:
          process.env.REACT_APP_API_URL_CONFIRMPAYMENT +
          `/download?date=${transationdateFormat}&refno=${paymentRefNo}&type=${history}`,
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
          "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
        },
      })
        // .then((res) => res.json())
        .then(async (response) => {
          setSetloading(false);
          var link = document.createElement("a");
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = await URL.createObjectURL(file);
          link.href = window.URL.createObjectURL(file);
          link.download = `Bill Payment form ${findBU(division)}_` + paymentRefNo + ".pdf";
          link.click();
          // setIsLoadingDownload(false)
          return response.data;
        });
    }
  };

  const downLoadInvoice = ( custmerNo, transectionDate, division, receiptNo ) => {
    // alert('clicked');
    setSetloading(true);
    let newUrl = `customercode=${custmerNo}&date=${transectionDate}&division=${division}&receiptNo=${receiptNo}`
    Axios({
      method: "GET", url: process.env.REACT_APP_API_URL_CONFIRMPAYMENT + `/reports/downloadReceiptDms?${newUrl}`,
      responseType: 'arraybuffer', headers: {
        "Content-Type": "application/json",
        'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
        'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
      }
    })
      .then(async (response) => {
        setSetloading(false);
        var link = document.createElement("a");
        const file = new Blob([response.data], { type: "application/pdf" });
          link.href = window.URL.createObjectURL(file);
          link.download = `Receipt_${findBU(division)}_` + receiptNo + ".pdf";
          link.click();
          return response.data;
      }).catch((err) => {
        setSetloading(false);
      })
  }

  const decimalwithcoma = (num) => {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  };

  const FontChange = useSelector(
    (state) => state.fontsizechanger.fontsizechanger
  );
  const HeadingFontChange = useSelector(
    (state) => state.headerfontchanger.headerfontchanger
  );
  const SmallFontChanger = useSelector(
    (state) => state.smallfontchanger.smallfontchanger
  );

  const downLoadPDFFile = (history = "history") => {
    // Axios({
    //   method: "GET",
    //   url:
    //     process.env.REACT_APP_API_URL_CONFIRMPAYMENT +
    //     "/credit/downloadPendingReport?customercode=" +
    //     localStorage.getItem("CustomerNumber") +
    //     "&division=" +
    //     props.division,
    //   responseType: "arraybuffer",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
    //     "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
    //   },
    // })
    // .then(async (response) => {

    // const response = [{"id":"639c28163c0a6f1f8a3ad0b2","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8020000610","invoiceDoc":"8020000610","postingDate":"2022-12-13","country":null,"division":"Cement","documentDate":"2022-12-13","netDueDate":"2022-12-13","lineItem":"001","customerPONumber":"SAP_สด_PJ_Mortar_Bulk_สระบุรี_TC_63","status":null,"shipto":null,"asondate":"2022-12-16","duedays":"3","soiNumber":null,"createdon":null,"reference":"8020000610","overdueAmount":"35811.30","overdueDays":3,"description":"15 Concrete Plastering Mortar - Bulk","docCurrency":"THB","amountDocCurrency":"35811.30","documentNo_FI":"4100000851","DocumentType":"INV","DueDate":"2022-12-13"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-16","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000335","paymentamountth":null,"paymentamountwords":"สามหมื่นห้าพันแปดร้อยสิบเอ็ดบาทสามสิบสตางค์","refSeq":null,"ponumber":"9200000335","division":"Cement","sapStatus":null,"customerName":"undefined","paymentamount":"35811.30","createdOn":"2022-12-16","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"6399ad8bf3cbce72cbcddc50","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"9010007385","invoiceDoc":"9010007385","postingDate":"2022-12-12","country":null,"division":"Cement","documentDate":"2022-12-12","netDueDate":"2023-01-09","lineItem":"001","customerPONumber":"SAP_เคร_Contract_Bag_สระบุรี_TC_52","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"-26","soiNumber":null,"createdon":null,"reference":"9010007385","overdueAmount":"0","overdueDays":null,"description":"INSEE DANG - BAGs","docCurrency":"THB","amountDocCurrency":"91.75","documentNo_FI":"4100000834","DocumentType":"INV","DueDate":"2023-01-09"},{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"9000000222","invoiceDoc":"9000000222","postingDate":"2022-12-12","country":null,"division":"Cement","documentDate":"2022-12-12","netDueDate":"2022-12-25","lineItem":"001","customerPONumber":"SAP_เคร_PJ_Mortar_Bag_UD_TC_80","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"-11","soiNumber":null,"createdon":null,"reference":"9000000222","overdueAmount":"0","overdueDays":null,"description":"13 Lightweight Block Pastering - Bag","docCurrency":"THB","amountDocCurrency":"9951.00","documentNo_FI":"4100000835","DocumentType":"INV","DueDate":"2022-12-25"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Siam Commercial Bank (SCB) - Business Net","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000334","paymentamountth":null,"paymentamountwords":"หนึ่งหมื่นสี่สิบสองบาทเจ็ดสิบห้าสตางค์","refSeq":null,"ponumber":"9200000334","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"10042.75","createdOn":"2022-12-14","updatedOn":"2022-12-14","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"In-Progress"},{"id":"639980333c0a6f1f8a3ac540","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8020000610","invoiceDoc":"8020000610","postingDate":"2022-12-13","country":null,"division":"Cement","documentDate":"2022-12-13","netDueDate":"2022-12-13","lineItem":"001","customerPONumber":"SAP_สด_PJ_Mortar_Bulk_สระบุรี_TC_63","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"1","soiNumber":null,"createdon":null,"reference":"8020000610","overdueAmount":"35811.30","overdueDays":1,"description":"15 Concrete Plastering Mortar - Bulk","docCurrency":"THB","amountDocCurrency":"35811.30","documentNo_FI":"4100000851","DocumentType":"INV","DueDate":"2022-12-13"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000333","paymentamountth":null,"paymentamountwords":"สามหมื่นห้าพันแปดร้อยสิบเอ็ดบาทสามสิบสตางค์","refSeq":null,"ponumber":"9200000333","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"35811.30","createdOn":"2022-12-14","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"63997fbd3c0a6f1f8a3ac53b","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8020000610","invoiceDoc":"8020000610","postingDate":"2022-12-13","country":null,"division":"Cement","documentDate":"2022-12-13","netDueDate":"2022-12-13","lineItem":"001","customerPONumber":"SAP_สด_PJ_Mortar_Bulk_สระบุรี_TC_63","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"1","soiNumber":null,"createdon":null,"reference":"8020000610","overdueAmount":"35811.30","overdueDays":1,"description":"15 Concrete Plastering Mortar - Bulk","docCurrency":"THB","amountDocCurrency":"35811.30","documentNo_FI":"4100000851","DocumentType":"INV","DueDate":"2022-12-13"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000332","paymentamountth":null,"paymentamountwords":"สามหมื่นห้าพันแปดร้อยสิบเอ็ดบาทสามสิบสตางค์","refSeq":null,"ponumber":"9200000332","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"35811.30","createdOn":"2022-12-14","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"63997f2d3c0a6f1f8a3ac536","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"9000000223","invoiceDoc":"9000000223","postingDate":"2022-12-12","country":null,"division":"Cement","documentDate":"2022-12-12","netDueDate":"2022-12-25","lineItem":"001","customerPONumber":"SAP_เคร_PJ_Mortar_Bag_UD_TC_80","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"-11","soiNumber":null,"createdon":null,"reference":"9000000223","overdueAmount":"0","overdueDays":null,"description":"13 Lightweight Block Pastering - Bag","docCurrency":"THB","amountDocCurrency":"18807.39","documentNo_FI":"4100000841","DocumentType":"INV","DueDate":"2022-12-25"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000331","paymentamountth":null,"paymentamountwords":"หนึ่งหมื่นแปดพันแปดร้อยเจ็ดบาทสามสิบเก้าสตางค์","refSeq":null,"ponumber":"9200000331","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"18807.39","createdOn":"2022-12-14","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"63997cf73c0a6f1f8a3ac528","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"9020000509","invoiceDoc":"9020000509","postingDate":"2022-12-12","country":null,"division":"Cement","documentDate":"2022-12-12","netDueDate":"2022-12-25","lineItem":"001","customerPONumber":"SAP_เคร_PJ_IMM_Bag_SRB_TC60_RE2","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"-11","soiNumber":null,"createdon":null,"reference":"9020000509","overdueAmount":"0","overdueDays":null,"description":"12 Fine Plastering IMM - BAG","docCurrency":"THB","amountDocCurrency":"15747.46","documentNo_FI":"4100000826","DocumentType":"INV","DueDate":"2022-12-25"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000330","paymentamountth":null,"paymentamountwords":"หนึ่งหมื่นห้าพันเจ็ดร้อยสี่สิบเจ็ดบาทสี่สิบหกสตางค์","refSeq":null,"ponumber":"9200000330","division":"Cement","sapStatus":"Success","customerName":"บจก.นฤมลกิจการค้า","paymentamount":"15747.46","createdOn":"2022-12-14","updatedOn":"2022-12-14","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Failed"},{"id":"63997c23f3cbce72cbcddb79","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"9020000509","invoiceDoc":"9020000509","postingDate":"2022-12-12","country":null,"division":"Cement","documentDate":"2022-12-12","netDueDate":"2022-12-25","lineItem":"001","customerPONumber":"SAP_เคร_PJ_IMM_Bag_SRB_TC60_RE2","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"-11","soiNumber":null,"createdon":null,"reference":"9020000509","overdueAmount":"0","overdueDays":null,"description":"12 Fine Plastering IMM - BAG","docCurrency":"THB","amountDocCurrency":"15747.46","documentNo_FI":"4100000826","DocumentType":"INV","DueDate":"2022-12-25"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000329","paymentamountth":null,"paymentamountwords":"หนึ่งหมื่นห้าพันเจ็ดร้อยสี่สิบเจ็ดบาทสี่สิบหกสตางค์","refSeq":null,"ponumber":"9200000329","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"15747.46","createdOn":"2022-12-14","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"63997a5df028b40a5629dbab","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8020000610","invoiceDoc":"8020000610","postingDate":"2022-12-13","country":null,"division":"Cement","documentDate":"2022-12-13","netDueDate":"2022-12-13","lineItem":"001","customerPONumber":"SAP_สด_PJ_Mortar_Bulk_สระบุรี_TC_63","status":null,"shipto":null,"asondate":"2022-12-14","duedays":"1","soiNumber":null,"createdon":null,"reference":"8020000610","overdueAmount":"35811.30","overdueDays":1,"description":"15 Concrete Plastering Mortar - Bulk","docCurrency":"THB","amountDocCurrency":"35811.30","documentNo_FI":"4100000851","DocumentType":"INV","DueDate":"2022-12-13"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-14","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000328","paymentamountth":null,"paymentamountwords":"สามหมื่นห้าพันแปดร้อยสิบเอ็ดบาทสามสิบสตางค์","refSeq":null,"ponumber":"9200000328","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"35811.30","createdOn":"2022-12-14","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"63970176f028b40a5629d0fc","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8010004192","invoiceDoc":"8010004192","postingDate":"2022-11-30","country":null,"division":"Cement","documentDate":"2022-11-30","netDueDate":"2022-11-30","lineItem":"001","customerPONumber":"I-1093359682","status":null,"shipto":null,"asondate":"2022-12-12","duedays":"12","soiNumber":null,"createdon":null,"reference":"8010004192","overdueAmount":"21079.00","overdueDays":12,"description":"INSEE DANG - BAGabcdefghijklmnopqrstuvwx","docCurrency":"THB","amountDocCurrency":"21079.00","documentNo_FI":"4100000804","DocumentType":"INV","DueDate":"2022-11-30"},{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8010004189","invoiceDoc":"8010004189","postingDate":"2022-11-28","country":null,"division":"Cement","documentDate":"2022-11-28","netDueDate":"2022-11-28","lineItem":"001","customerPONumber":"1611202222222","status":null,"shipto":null,"asondate":"2022-12-12","duedays":"14","soiNumber":null,"createdon":null,"reference":"8010004189","overdueAmount":"21079.00","overdueDays":14,"description":"INSEE DANG - BAGabcdefghijklmnopqrstuvwx","docCurrency":"THB","amountDocCurrency":"21079.00","documentNo_FI":"4100000802","DocumentType":"INV","DueDate":"2022-11-28"}],"paymentmode":"Online","docCurrency":null,"transationdate":"2022-12-12","paymenttype":"DirectDebit","paymentbank":"Krungsri Bank - Krungsri Online","reciptnumber":null,"reciptyear":null,"paymentRefNo":"9200000327","paymentamountth":null,"paymentamountwords":"สี่หมื่นสองพันหนึ่งร้อยห้าสิบแปดบาทถ้วน","refSeq":null,"ponumber":"9200000327","division":"Cement","sapStatus":null,"customerName":"บจก.นฤมลกิจการค้า","paymentamount":"42158.00","createdOn":"2022-12-12","updatedOn":"2022-12-27","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Suspicious."},{"id":"635bf54970945549876a4729","invoiceid":[{"id":null,"paymentId":null,"companyCode":"1000","customerCode":"0110008926","billingDoc":"8000000307","invoiceDoc":"8000000307","postingDate":"2022-10-19","country":null,"division":"Cement","documentDate":"2022-10-19","netDueDate":"2022-10-19","lineItem":"001","customerPONumber":"I-1548054848","status":null,"shipto":null,"asondate":"2022-10-28","duedays":"9","soiNumber":null,"createdon":null,"reference":"8000000307","overdueAmount":"42440.91","overdueDays":9,"description":"INSEE Petch Easy Flow (Bulk)","docCurrency":"THB","amountDocCurrency":"42440.91","documentNo_FI":"4100000754","DocumentType":"INV","DueDate":"2022-10-19"}],"paymentmode":"Offline","docCurrency":null,"transationdate":"2022-10-28","paymenttype":"Bill Payment(BP)","paymentbank":"","reciptnumber":null,"reciptyear":null,"paymentRefNo":"8200000614","paymentamountth":null,"paymentamountwords":"สี่หมื่นสองพันสี่ร้อยสี่สิบบาทเก้าสิบเอ็ดสตางค์","refSeq":null,"ponumber":null,"division":"Cement","sapStatus":"Sucess","customerName":"บจก.นฤมลกิจการค้า","paymentamount":"42440.91","createdOn":"2022-10-28","updatedOn":"2022-10-28","createdBy":null,"soldToNumber":"0110008926","paymentstatus":"Cancelled"}]

    const response = rowsData;
    var link = document.createElement("a");
    const file = new Blob([response.results], { type: "application/xlsx" });
    const fileURL = URL.createObjectURL(file);
    const dateAndTime = moment().format("DD_MM_YYYY_HH_mm_ss");

    link.href = window.URL.createObjectURL(file);
    link.download = "OpenItem" + dateAndTime + ".xlsx";
    link.click();
    console.log("hello1", file);
    console.log("hello2", fileURL);
    // console.log();
    // setSetloading(false)
    return response.data;
    // });
  };

  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([]);
  const [open, setOpen] = useState(false);

  function exportExcelFile(file_url) {
    setExportFiles([]);
    Axios({
      method: "GET",
      url:
        process.env.REACT_APP_API_URL_CONFIRMPAYMENT +
        `/onlinePayment/bucket?folderName=${file_url}`,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        const newRes = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setExportFiles(newRes);
      })
      .catch((err) => {
        // setExportState({ btnName: "EXPORT" });
      });
  }

  const lancode = localStorage.getItem("lancode");

  function exportApiCAll() {
    const postObj = {
      soldtonumber: custNo,
      division: props.division,
      countryCode: lancode,
      refno: props.filterData ? props.filterData : "",
      excel: "true",
      fromIndex: 1,
      toIndex: 10,
      fromdate: props.fromDateTransDate ? props.fromDateTransDate : "",
      todate: props.toDateTransDate ? props.toDateTransDate : "",
    };

    const url = `/onlinePayment/export/history`;

    Axios({
      method: "POST",
      url: process.env.REACT_APP_API_URL_CONFIRMPAYMENT + url,
      data: postObj,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setOpen(true);
        setFileUrl(response.data.data);
        exportExcelFile(response.data.data);
      })
      .catch((err) => {});
  }

  // const formatPaymentBankName = (bankName) => {
  //   if (bankName === "SCB") {
  //     return "Siam Commercial Bank (SCB) - Business Net";
  //   } else if(bankName === "BayBank" || bankName === "BAY"){
  //     return "Krungsri Bank - Krungsri Online";
  //   } else if (bankName === "KBANK" || bankName === "KBankCF" || bankName === "KBankDD") {
  //     return "Kasikorn Bank - K-Cash Connect";
  //   }
  // };

  const formatPaymentBankName = (bankName) => {
    if (bankName === "SCB") {
      return `${t("bank.scbbank")}`;
    } else if (bankName === "BAY" || bankName === "BayBank") {
      return `${t("bank.baybank")}`;
    } else if (bankName === "KBANK" || bankName === "KBankCF" || bankName === "KBankDD") {
      return `${t("bank.kbank")}`;
    }
  };

  return (
    <div className="table-resp">
      <div className="col-md-12 text-right mb-2">
        {/* <ExportJsonDataToExcel
          fileName="Payment-History"
          columnName={column}
          tableData={rows?.results}
          classes="text-primary"
          textSize="12px"
          iconSize="14px"
        /> */}
        <ExportExcelPopup
          title={"Customer"}
          fileName={"customer"}
          setOpen={setOpen}
          open={open}
          exportExcelFile={exportExcelFile}
          fileUrl={fileUrl}
          exportFiles={exportFiles}
        />
        <Button
          className="text-primary"
          style={{ fontSize: "12px" }}
          startIcon={<DownloadIcon style={{ fontSize: "14px" }} />}
          onClick={exportApiCAll}
        >
          {t("payment_export")}
        </Button>
        <button
          className={classes.refreshButton}
          onClick={props.refresPendingData}
        >
          <img src={RefreshIcon} alt="refresh" title="Refresh" />
        </button>
      </div>
      {loading ? (
        <div className={classes.loadingOne}>
          {" "}
          <Loading />{" "}
        </div>
      ) : (
        ""
      )}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ fontSize: `${SmallFontChanger}px` }}>
                {t("label.payment_ref_no")}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="right"
              >
                {t("Document Type")}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="center"
              >
                {t("label.bankname")}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="center"
              >
                {t("Transaction date")}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="center"
                className={classes.textRight}
              >
                {t("label.total_amount")}
                {selectedLangCode === "en" || selectedLangCode === null
                  ? `(${
                      rows && rows.results.length > 0
                        ? rows && rows.results[0].invoiceid[0].docCurrency
                        : ""
                    })`
                  : rows && rows.results.length > 0
                  ? rows && rows.results[0].invoiceid[0].docCurrency === "THB"
                    ? "(บาท)"
                    : ""
                  : rows && rows.results.length > 0
                  ? rows && rows.results[0].invoiceid[0].docCurrency === "USD"
                    ? "(ดอลล่าร์)"
                    : ""
                  : `(${
                      rows && rows.results.length > 0
                        ? rows && rows.results[0].invoiceid[0].docCurrency
                        : ""
                    })`}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="center"
              >
                {t("Status")}
              </StyledTableCell>
              <StyledTableCell
                style={{ fontSize: `${SmallFontChanger}px` }}
                align="right"
              >
                {t("Actions")}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.totalCount > 0 ? (
              rows &&
              rows.results.map((row) => (
                <StyledTableRow key={row.name} className={classes.tableBody}>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    style={{ fontSize: `${SmallFontChanger}px` }}
                  >
                    <Link
                      to={{
                        pathname: "/PaymentRefrence",
                        state: { id: row.id },
                      }}
                    >
                      {row.paymentRefNo}
                    </Link>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: `${SmallFontChanger}px` }}
                    align="right"
                  >
                    {row.paymenttype &&
                    (row.paymenttype === "DirectDebit" ||
                      row.paymenttype === "DD")
                      ? "Online Direct Debit"
                      : row.paymenttype === "CF"
                      ? "Customer Financing"
                      : row.paymenttype}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: `${SmallFontChanger}px` }}
                    align="right"
                  >
                    {/* {row.paymentbank === "BayBank" ? :} */}
                    {/* {row.paymentbank} */}
                    {formatPaymentBankName(row.paymentbank)}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: `${SmallFontChanger}px` }}
                    align="right"
                  >
                    {moment(row.transationdate).format("DD-MM-YYYY")}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: `${SmallFontChanger}px` }}
                    align="right"
                    className={classes.textRight}
                  >
                    {decimalwithcoma(row.paymentamount)}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: `${SmallFontChanger}px` }}
                    align="right"
                  >
                    <span className="sattled-color">
                      {row.paymentstatus && row.paymentstatus === "Suspicious."
                        ? "Failed"
                        : row.paymentstatus}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.paymentmode.toLowerCase() === "online" && (
                      <div
                        className="receipt_action"
                        style={{ fontSize: `${SmallFontChanger}px` }}
                      >
                        <Box className="actions">
                          {(row.paymentstatus || "").toUpperCase() ===
                            "Receipt".toUpperCase() && (
                            <Box
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                              onClick={() =>
                                // viewPdfFile(
                                //   row.division,
                                //   row.transationdate,
                                //   row.reciptnumber
                                // )
                                downLoadInvoice(row.invoiceid[0].customerCode, row.reciptyear, row.division, row.reciptnumber)
                              }
                            >
                              <i
                                class="fa fa-file-pdf-o"
                                aria-hidden="true"
                              ></i>
                            </Box>
                          )}

                          {row.paymentstatus === "Receipt"
                            ? ""
                            : row.paymenttype === "DirectDebit" &&
                              row.paymentstatus === "In-Progress"
                            ? ""
                            : row.paymentmode.toLowerCase() !== "online" && (
                                <Box
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => props.handleOpen(row.id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </Box>
                              )}
                        </Box>
                      </div>
                    )}
                    {row.paymentmode.toLowerCase() !== "online" && (
                      <div
                        className="receipt_action"
                        style={{ fontSize: `${SmallFontChanger}px` }}
                      >
                        {row.paymenttype === "DirectDebit" &&
                        row.paymentstatus === "In-Progress" ? (
                          ""
                        ) : row.paymentstatus === "Cancelled" ||
                          row.paymentstatus === "Processing" ||
                          (row.paymentstatus &&
                            row.paymentstatus === "Failed") ||
                          row.paymentstatus === "Fail" ||
                          row.paymentstatus === "Failure" ||
                          (row.paymentstatus &&
                            row.paymentstatus === "Suspicious.") ? (
                          ""
                        ) : (
                          <Box className="actions">
                            {
                              <Box
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() =>
                                  viewPdfFile(
                                    row.paymentRefNo,
                                    row.transationdate,
                                    row.paymentstatus,
                                    row.reciptnumber,
                                    row.division,
                                    row.reciptyear
                                  )
                                }
                              >
                                <i
                                  class="fa fa-file-pdf-o"
                                  aria-hidden="true"
                                ></i>
                              </Box>
                            }

                            {row.paymentstatus === "Receipt"
                              ? ""
                              : row.paymenttype === "DirectDebit" &&
                                row.paymentstatus === "In-Progress"
                              ? ""
                              : row.paymentmode.toLowerCase() !== "online" && (
                                  <Box
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => props.handleOpen(row.id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Box>
                                )}
                          </Box>
                        )}
                      </div>
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow className={classes.tableBody}>
                <div className="noBankFound">{t("Data not available")}</div>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={props.handleClose}
        ></DialogTitle>
        <DialogContent>
          <Typography>
            <p className="mb-0">
              {t("Are you sure want to remove this payment history?")}
            </p>
            {/* <p className="mb-0 text-secondary">Are you sure</p> */}
          </Typography>
          <DialogActions>
            <div className="create_link d-flex pull-center">
              <button
                className="create p-2 pl-3 pr-3"
                onClick={props.deleteData}
              >
                {t("pickupform.yes")}
              </button>
              <button
                className="create p-2 pl-3 pr-3"
                onClick={props.handleClose}
              >
                {t("pickupform.no")}
              </button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <div className="col-md-12 text-right py-4">
        {
          <Pagination
            count={Math.ceil(rows && rows.totalCount / 10)}
            page={page}
            onChange={props.handleChangePage}
            siblingCount= {0}
            size="small"
          />
        }
      </div>
    </div>
  );
}